import IconNotes from 'assets/icon_notes.svg';
import InternalCandidateNotes from 'components/Profile/InternalCandidateNotes/InternalCandidateNotes';
import { InternalNotesProps } from './types';

const InternalNotes: React.FC<InternalNotesProps> = ({
  adminUsers,
  handleUpdateInternalCandidateNotes,
  notes,
  deleteNote,
  deletionModalRef,
}) => {
  return (
    <div className={`profile-section`}>
      <h4 className="section-header mb1 mr1 inline-block">Internal Notes</h4>
      <div className="profile-section-icon-div">
        <img src={IconNotes} alt="internal notes" />
      </div>
      <InternalCandidateNotes
        notes={notes ?? []}
        deleteNote={deleteNote}
        updateNote={handleUpdateInternalCandidateNotes}
        adminUsers={adminUsers}
        deletionModalRef={deletionModalRef}
      />
    </div>
  );
};

export default InternalNotes;
